/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, n: NonNullable<unknown> }} Decks_View_Entry_RoundInputs */



/**
* | output |
* | --- |
* | "{name} (round {n})" |
*
* @param {Decks_View_Entry_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_view_entry_round = /** @type {((inputs: Decks_View_Entry_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_View_Entry_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} (ronde ${i?.n})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} (ronda ${i?.n})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} (rodada ${i?.n})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} (round ${i?.n})`)
	return /** @type {LocalizedString} */ (`${i?.name} (round ${i?.n})`)
});